import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardContent, Typography, Grid, Box } from '@mui/material';
import PendingIcon from '@mui/icons-material/Pending';
import DataTable from '../../dataTable/DataTable/DataTable';
import { UserMachinesContext } from '../contexts/UserMachinesContext';
import UserMachineInformation from '../components/UserMachineInformation';
import defaultUserMachineColumns from '../constants/defaultUserMachineColumns';
import { Machine } from '../../machinesAdminManagement/model';
import { AuthContext } from '../../auth/contexts/AuthContext';
import UserMachinesFilterBar from '../components/UserMachinesFilterBar';

const UserMachinesList: React.FunctionComponent = () => {
  const history = useHistory();
  const { currentUserHasAdminPermission, currentUserHasUserPermission } = React.useContext(AuthContext);
  const { fetchUserMachines, accountMachines, machinesLoading } = React.useContext(UserMachinesContext);
  const [activeMachine, setActiveMachine] = React.useState<any>();
  const [initialDataLoaded, setDataLoaded] = React.useState(false);
  const [filterValues, setFilterValues] = React.useState();

  React.useEffect(() => {
    fetchUserMachines();
  }, []);

  return (
    <Box>
      <Grid item>
        <Typography variant="h1" component="h1">
          Machine Management
        </Typography>
        <br />
      </Grid>
      <br />
      <UserMachinesFilterBar allMachines={false} filterValues={filterValues} setFilterValues={setFilterValues} />
      <br />
      <Card>
        <CardContent>
          <DataTable
            noHeader
            columns={defaultUserMachineColumns}
            data={accountMachines}
            onRowClicked={(row: Machine) => setActiveMachine(row)}
            defaultSortAsc={false}
            striped
            highlightOnHover
            pointerOnHover
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[5, 10, 25]}
            progressPending={machinesLoading}
          />
        </CardContent>
      </Card>
      <br />
      {!machinesLoading && (
        <>
          {activeMachine ? (
            <Grid justifyContent="space-between" container spacing={3}>
              <Grid item xs={12} md={12}>
                <UserMachineInformation machine={activeMachine} />
              </Grid>
            </Grid>
          ) : (
            <Card>
              <CardContent>
                <Grid justifyContent="center" container spacing={1} marginTop="50">
                  <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
                    <Typography variant="h1" component="h1">
                      Please select a machine to view details.
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          )}
        </>
      )}
    </Box>
  );
};

export default UserMachinesList;
